<ng-template #SingleLevelView
	[ngIf]="tabItems.length === 0"
	[ngIfElse]="MultiLevelView">
	<p-tabMenu
		[model]="sectionItems"
		[activeItem]="activeSectionItem">
		<ng-template
			pTemplate="sectionItems"
			let-sectionItem
			let-i="index">
			<div (click)="sectionMenuItemClicked()">
				<div class="p-menuitem-icon double-font-size"
					[ngClass]="sectionItem.icon"
					*ngIf="sectionItem.icon">
				</div>
				<a class="btn btn-link"
					[ngClass]="{
						'active-tab': (activeSectionItem != null && sectionItem.label === activeSectionItem.label)
					}">
					{{sectionItem.label}}
					<span class="visually-hidden"
						*ngIf="shouldShowSectionDot(sectionItem.label)">
						has validation issues
					</span>
					<i class="fa fa-asterisk violation-indicator"
						aria-hidden="true"
						*ngIf="shouldShowSectionDot(sectionItem.label)">
					</i>
				</a>
			</div>
		</ng-template>
	</p-tabMenu>
</ng-template>
<ng-template #MultiLevelView>
	<p-tabView
		(onChange)="tabSelected($event)">
		<ng-template ngFor
			let-tabItem
			[ngForOf]="tabItems">
			<p-tabPanel
				[selected]="tabItem === activeTabItem">
				<ng-template pTemplate="header">
					<span class="p-tabview-title">
						{{tabItem.label}}
					</span>
					<span class="visually-hidden"
						*ngIf="shouldShowDot(tabItem.label)">
						has validation issues
					</span>
					<i class="fa fa-asterisk violation-indicator"
						aria-hidden="true"
						*ngIf="shouldShowDot(tabItem.label)">
					</i>
				</ng-template>
				<p-tabMenu
					[model]="tabItem.items"
					[activeItem]="activeSectionItem">
					<ng-template
						pTemplate="sectionItems"
						let-sectionItem
						let-i="index">
						<div (click)="sectionMenuItemClicked()">
							<div class="p-menuitem-icon double-font-size"
								[ngClass]="sectionItem.icon"
								*ngIf="sectionItem.icon">
							</div>
							<a class="btn btn-link"
								[ngClass]="{
									'active-tab': (activeSectionItem != null && sectionItem.label === activeSectionItem.label)
								}">
								{{sectionItem.label}}
								<span class="visually-hidden"
									*ngIf="shouldShowSectionDot(sectionItem.label)">
									has validation issues
								</span>
								<i class="fa fa-asterisk violation-indicator"
									aria-hidden="true"
									*ngIf="shouldShowSectionDot(sectionItem.label)">
								</i>
							</a>
						</div>
					</ng-template>
				</p-tabMenu>
			</p-tabPanel>
		</ng-template>
	</p-tabView>
</ng-template>